import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import { INDUSTRIAL_FAQ_BY_LOCALE } from '@/data/shared/industrialFaq';

import { SolutionFaqSection } from '../../shared/SolutionFaqSection';

/**
 * ### IndustrialFaqSection
 *
 * Places the shared FAQ section on the Listen AI Industrial page with the
 * Industrial copy, which is the same list the page emits as FAQPage structured
 * data, so the rendered questions and the schema can never drift.
 *
 * @returns The rendered FAQ section element
 * @see {@link INDUSTRIAL_FAQ_BY_LOCALE} The copy rendered here
 * @see {@link SolutionFaqSection} The shared section this configures
 */
export default function IndustrialFaqSection() {
  const { t } = useTranslation('common');
  const currentLang = useCurrentLang();

  return (
    <SolutionFaqSection
      tone="dark"
      analyticsSectionId="industrial_faq"
      title={t('자주 묻는 질문')}
      description={t(
        'Listen AI Industrial 도입 전에 가장 많이 받는 질문을 정리했습니다.',
      )}
      items={INDUSTRIAL_FAQ_BY_LOCALE[currentLang]}
    />
  );
}
